import { BENEFICIAL_INSECTS } from './beneficialInsects';
import { REMEDIES } from './remedies';

// Derived at module load — single source of truth in beneficialInsects.ts and remedies.ts
function buildBeneficialMap(): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  for (const insect of BENEFICIAL_INSECTS) {
    for (const pestId of insect.controlsPests) {
      (map[pestId] ??= []).push(insect.id);
    }
  }
  return map;
}

function buildRemedyMap(): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  for (const remedy of REMEDIES) {
    for (const pestId of remedy.usedFor) {
      (map[pestId] ??= []).push(remedy.id);
    }
  }
  return map;
}

export const PEST_BENEFICIAL_MAP: Record<string, string[]> = buildBeneficialMap();
export const PEST_REMEDY_MAP: Record<string, string[]> = buildRemedyMap();

export function getPestBeneficialIds(pestId: string, max = 2): string[] {
  return (PEST_BENEFICIAL_MAP[pestId] ?? []).slice(0, max);
}

export function getPestRemedyIds(pestId: string, max = 2): string[] {
  return (PEST_REMEDY_MAP[pestId] ?? []).slice(0, max);
}
